export default __webpack_public_path__ + "static/media/s-m.16b646a9.jpg";